import $ from 'jquery'

$(() => {
  $('[data-toggle="popover"]').popover()
})

$(() => {
  $('[data-toggle="tooltip"]').tooltip()
})
